import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ButtonWrapper,
} from '../../components';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="NotFound">
      <h1>{t('pages.404.title')}</h1>
      <p>{t('pages.404.body')}</p>
      <div className="Buttonwrapper">
        <ButtonWrapper href={t('pages.404.primary_button.url')}>{t('pages.404.primary_button.link')}</ButtonWrapper>
        <ButtonWrapper type="secondary" href={t('pages.404.secondary_button.url')}>{t('pages.404.secondary_button.link')}</ButtonWrapper>
      </div>
    </div>
  );
};

export default NotFound;
